import Component from "../classes/Component"
import each from 'lodash/each'

import { app, menu, navigation } from '../utils/store'

import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export class BottomBar extends Component {
    constructor({ init = false }){
        super({
            element: '[data-navigation-bottom-bar]',
            elements: {
                actions: '[data-main-actions]',
                cta: '[data-main-cta]',
                dropdowns: 'dropdown-menu',
            }
        })
    }
    
    create(){
        super.create()
        
        app.statusbar = this.element

        if(this.element){
            app.root.style.setProperty('--bottom-bar-height', `${app.statusbar.clientHeight}px`)
        } else {
            app.root.style.setProperty('--bottom-bar-height', `0px`)
        }

        if(this.elements.cta){
            app.root.style.setProperty('--bottom-bar-cta-height', `${this.elements.cta.clientHeight}px`)
        } else {
            app.root.style.setProperty('--bottom-bar-cta-height', `0px`)
        }

        if(this.elements.actions){
            app.root.style.setProperty('--bottom-bar-actions-height', `${this.elements.actions.clientHeight}px`)
        } else {
            app.root.style.setProperty('--bottom-bar-actions-height', `60px`)
        }
    }
    
    addEventListeners(){
        window.addEventListener('resize', () => {
            if(this.element){
                app.root.style.setProperty('--bottom-bar-height', `${app.statusbar.clientHeight}px`)
            } else {
                app.root.style.setProperty('--bottom-bar-height', `0px`)
            }

            if(this.elements.cta){
                app.root.style.setProperty('--bottom-bar-cta-height', `${this.elements.cta.clientHeight}px`)
            } else {
                app.root.style.setProperty('--bottom-bar-cta-height', `0px`)
            }

            if(this.elements.actions){
                app.root.style.setProperty('--bottom-bar-actions-height', `${this.elements.actions.clientHeight}px`)
            } else {
                app.root.style.setProperty('--bottom-bar-actions-height', `0px`)
            }
        })

        if(app.scroll){
            app.scroll.addEventListener('scroll', () => this.onScroll())
        }
    }

    onScroll = (event) => {
        if(app.scroll == window){ this.scrollTop = window.scrollY } 
        else { this.scrollTop = app.scroll.scrollTop }

        if (this.scrollTop > app.nav.clientHeight) {
            this.element.classList.add('statusbar--active')
        } else {
            this.element.classList.remove('statusbar--active')
        }
    }

    destroy = () => { /** Code your own */ }
}